<div class="container-fluid p-4" role="main" aria-label="HUM Campaigns Dashboard">
    <div class="content" [ngClass]="{'loading-content': hasAnyLoadingState()}">
       
        <!-- Filters Section -->
        <!-- Campaign Filter -->
        <app-campaign-filter
            [showAllCampaignsOption]="true"
            [CampaignType]="2"
            (performanceRequested)="onCampaignSelected($event)">
        </app-campaign-filter>
        
        <!-- Campaign Funnel -->
        <div class="editorial-funnel-card p-4 mb-4">
          <!-- <div *ngIf="chartLoadingStates.funnel" class="card-loader-overlay">
            <app-loader [showMessage]="false" [size]="'large'"></app-loader>
          </div> -->          
          <div *ngIf="loadingStates['funnel']" class="d-flex justify-content-center align-items-center" style="height: 200px;">
            <app-loader [showMessage]="false" [size]="'medium'"></app-loader>
          </div>
          
          <div class="d-flex align-items-center mb-4 position-relative">
            <h3 class="mb-0 chart-title">
              Campaign Funnel              
            </h3>
            <span class="info-btn-wrapper ms-2">
              <button type="button" class="editorial-funnel-info-btn" tabindex="0"
                (click)="showCampaignFunnelInfo = !showCampaignFunnelInfo"
                aria-label="Show campaign funnel information">
                <i class="bi bi-info-circle"></i>
              </button>
              <div *ngIf="showCampaignFunnelInfo" class="chart-info-tooltip">
                <div class="tooltip-content">
                  <div *ngFor="let info of campaignFunnelLegendInfo" class="legend-item">
                    <span class="legend-key">{{info.key}}:</span>
                    <span class="legend-definition">{{info.definition}}</span>
                  </div>
                </div>
              </div>
            </span>
            <span *ngIf="selectedCampaignName" class="campaign-name-badge ms-2">{{ selectedCampaignName }}</span>
          </div>
          <!-- <div *ngIf="chartLoadingStates.funnel" class="d-flex justify-content-center align-items-center" style="height: 120px;">
            <div class="spinner-border text-primary" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
          </div> -->          
          <ng-container *ngIf="!loadingStates['funnel']">
            <div *ngFor="let stage of funnelStages; let i = index" class="mb-3">
              <div class="d-flex justify-content-between align-items-center mb-1">
                <span class="fw-semibold">{{ stage.stage }}</span>
                <span class="fw-semibold">
                  <!-- <span style="border-radius: 3px; padding: 0 2px;">{{ stage.count | number }}</span> ({{ stage.percentage | number:'1.1-1' }}%) -->
                  <ng-container *ngIf="stage.stage !== 'Conversion Rate'; else conversionRateDisplay">
                    <span style="border-radius: 3px; padding: 0 2px;">{{ stage.count | number }}</span> ({{ stage.percentage | number:'1.1-1' }}%)
                  </ng-container>
                  <ng-template #conversionRateDisplay>
                    <span style="border-radius: 3px; padding: 0 2px;">{{ stage.percentage | number:'1.1-1' }}%</span>
                  </ng-template>
                </span>
              </div>
              <div class="progress" style="height: 16px;">
                <div class="progress-bar" role="progressbar"
                  [ngStyle]="getCampaignFunnelBarStyle(i)"
                  [style.width]="stage.percentage + '%'"
                  [attr.aria-valuenow]="stage.percentage"
                  aria-valuemin="0" aria-valuemax="100">
                </div>
              </div>
            </div>
          </ng-container>
        </div>
        
        <!-- Charts Section -->
        <div class="row g-4">
            <!-- Conversions vs Dismissals Chart -->
            <div class="col-12">
                <div class="chart-container" role="region" aria-label="Conversions vs Dismissals Trends Chart">
                  <div class="d-flex align-items-center mb-3 position-relative">
                    <h3 class="mb-0 chart-title">Conversion Trend</h3>
                    <span class="info-btn-wrapper ms-2">
                      <button type="button" class="editorial-funnel-info-btn" tabindex="0"
                        (click)="showConversionsVsDismissalsInfo = !showConversionsVsDismissalsInfo"
                        aria-label="Show conversions vs dismissals chart information">
                        <i class="bi bi-info-circle"></i>
                      </button>
                      <div *ngIf="showConversionsVsDismissalsInfo" class="chart-info-tooltip">
                        <div class="tooltip-content">
                          <div *ngFor="let info of conversionsVsDismissalsLegendInfo" class="legend-item">
                            <span class="legend-key">{{info.key}}:</span>
                            <span class="legend-definition">{{info.definition}}</span>
                          </div>
                        </div>
                      </div>
                    </span>
                  </div>
                  <app-line-area-chart 
                      [title]="''" 
                      [data]="impressionsVsConversionData" 
                      [series]="impressionsVsConversionSeries" 
                      [fileName]="'conversions-vs-dismissals.png'" 
                      [defaultType]="'line'" 
                      [showToggle]="true" 
                      [lineOnly]="false"                                                 
                      height="400px" 
                      [loading]="loadingStates['impressionsVsConversion']"
                      [powerBiUrl]="'https://app.powerbi.com/groups/932e7989-a8b9-4046-b5ec-65f5ab7fdff8/list?experience=power-bi'">
                  </app-line-area-chart>
                </div>
            </div>
        </div>
    </div>      
</div> 